import React from 'react';
import { FaRegClock, FaMapMarkerAlt } from 'react-icons/fa';
import {
  ScheduleWrapper,
  ScheduleTitle,
  ScheduleList,
  ScheduleCard,
  ScheduleHeader,
  ScheduleName,
  CoursePill,
  DetailsButton,
  MetaRow,
  MetaItem,
  Note,
} from './Schedule.styles';

const scheduleItems = [
  {
    title: 'Office Hours - Prof. Adams',
    course: 'CS 301',
    time: '9:00 AM (1 hour)',
    location: 'Science Hall 205',
    note: '',
    variant: 'success' as const,
  },
  {
    title: 'Data Structures & Algorithms',
    course: 'CS 301',
    time: '10:00 AM (1h 15min)',
    location: 'Science Hall 204',
    note: '',
    variant: 'neutral' as const,
  },
  {
    title: 'Computer Science Club Meeting',
    course: '',
    time: '12:00 PM (1 hour)',
    location: 'Student Union 304',
    note: 'Planning for upcoming hackathon',
    variant: 'danger' as const,
  },
  {
    title: 'Discrete Mathematics',
    course: 'MATH 310',
    time: '1:00 PM (1h 15min)',
    location: 'Mathematics Building 105',
    note: '',
    variant: 'neutral' as const,
  },
  {
    title: 'Study Group - Algorithms',
    course: '',
    time: '3:30 PM (2 hours)',
    location: 'Library Study Room B',
    note: 'Preparing for midterm project',
    variant: 'warning' as const,
  },
  {
    title: 'Engineering Society Social',
    course: '',
    time: '6:00 PM (2 hours)',
    location: 'Campus Center Lounge',
    note: 'Welcome new members',
    variant: 'danger' as const,
  },
];

const Schedule: React.FC = () => {
  return (
    <ScheduleWrapper>
      <ScheduleTitle>
        <span role="img" aria-label="calendar">🗓️</span> Today's Schedule - Sunday, October 20, 2024
      </ScheduleTitle>
      <ScheduleList>
        {scheduleItems.map((item) => (
          <ScheduleCard key={item.title} $variant={item.variant}>
            <ScheduleHeader>
              <ScheduleName>
                {item.title}
                {item.course && <CoursePill>{item.course}</CoursePill>}
              </ScheduleName>
              <DetailsButton>Details</DetailsButton>
            </ScheduleHeader>
            <MetaRow>
              <MetaItem><FaRegClock /> {item.time}</MetaItem>
              <MetaItem><FaMapMarkerAlt /> {item.location}</MetaItem>
            </MetaRow>
            {item.note && <Note>{item.note}</Note>}
          </ScheduleCard>
        ))}
      </ScheduleList>
    </ScheduleWrapper>
  );
};

export default Schedule;


